import APIKit from '../Allapis/Apikit/apikit'

export const getCategoriesServer = async id => {
  const endpoint = id
    ? `/promotions/getCategories/${id}`
    : `/promotions/getCategories`
  const res = await APIKit.get(endpoint)
  return res.data
}

export const createCategoriesServer = async values => {
  try {
    const res = await APIKit.post(`/promotions/categories`, values)
    return res.data
  } catch (error) {
    console.error('Error creating category:', error)
    throw error
  }
}

export const updateCategoriesServer = async (id, values) => {
  try {
    const res = await APIKit.post(`/promotions/categories/${id}`, values)
    return res.data
  } catch (error) {
    console.error('Error updating category:', error)
    throw error
  }
}

export const deleteCategoriesServer = async del_id => {
  const res = await APIKit.put(`/promotions/categories/${del_id}`)
  return res.data
}
